import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'ForgotPassword',
  properties: {
    passwordResetEmail: String,
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/forgot_password.js